// extracted by mini-css-extract-plugin
export var favnotification = "MyFavouritesIcon-module--favnotification--12bce";
export var favnotificationie = "MyFavouritesIcon-module--favnotificationie--90643";